import { render, staticRenderFns } from "./registry-search-filter.vue?vue&type=template&id=1dfeaee4&scoped=true&"
import script from "./registry-search-filter.ts?vue&type=script&lang=ts&"
export * from "./registry-search-filter.ts?vue&type=script&lang=ts&"
import style0 from "./registry-search-filter.scss?vue&type=style&index=0&id=1dfeaee4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfeaee4",
  null
  
)

export default component.exports